import _ from "lodash";
import React from "react";
import { useLazyGetFeesSummaryQuery } from "../../../services/headofficeadmin";

export const FeesSummaryContext = React.createContext();

export const useFeesSummaryData = () => React.useContext(FeesSummaryContext);

export const FeesSummaryProvider = ({ children, filter = null, isReady = false }) => {
    const [load, { data, error, isLoading, isFetching }] = useLazyGetFeesSummaryQuery();

    const reload = () => {
        if (!isReady || !filter || _.isEmpty(filter)) {
            return;
        }
        load({ ...filter }).unwrap();
    };

    React.useEffect(reload, [ filter, isReady ]);

    return (
        <FeesSummaryContext.Provider value={{ data, error, isFetching, isLoading }}>
            {children}
        </FeesSummaryContext.Provider>
    )
}
